module.exports = __webpack_public_path__ + "success.de4ee7ad58f75b356c97.svg";


//////////////////
// WEBPACK FOOTER
// C:/WORK/ZENN/mcr-contabilidade-fileshare/Application/ApplicationUI/src/assets/images/icon/success.svg
// module id = ../../../../../src/assets/images/icon/success.svg
// module chunks = styles